import {Request} from "../utils/request";

export const CatchErrorsAPI = {
    createError: (dto: any) => {
        Request.post(`frontend-error/`, dto)
    }
}
